<template>
  <app-content class="h-panel">
    <div class="h-panel-bar ">
      <span class="h-panel-title">资产调出明细</span>
      <span class="dark4-color">提示：按 Ctrl + F 键并输入信息可以快速查找。</span>
    </div>
    <div class="margin-right-left margin-top">
      <Button color="primary" @click="exportExcel">导出Excel</Button>
    </div>
    <div class="h-panel-body">
      <Table :datas="disposalData" :border="true">
        <TableItem title="序号" :width="50">
          <template v-slot="{ index }">{{ index + 1 }} </template>
        </TableItem>
        <TableItem title="资产编号" prop="assetsCode" ></TableItem>
        <TableItem title="资产类别" prop="assetsTypeName"></TableItem>
        <TableItem title="资产名称" prop="assetsName"  :width="200"></TableItem>
        <TableItem title="单位" prop="specification"></TableItem>
        <TableItem title="录入时间" prop="luruDate"></TableItem>
        <TableItem title="调出数量" prop="disposalNumber" :width="60"></TableItem>
        <TableItem title="调出时间" prop="disposalDate"></TableItem>
        <TableItem title="调出说明" prop="disposal"></TableItem>
        <TableItem title="单价" prop="price"></TableItem>
        <TableItem title="数量" prop="number" :width="50"></TableItem>
        <TableItem title="资产原值" prop="originalValue"></TableItem>
        <TableItem title="折旧次数" prop="expectUseMonth" :width="60"></TableItem>
        <TableItem title="单次折旧额" prop="currentMonthDepreciation"></TableItem>
        <TableItem title="折旧起始日期" prop="checkDate"></TableItem>
        <TableItem title="上次折旧日期" prop="entryDate"></TableItem>
        <TableItem title="剩余次数" prop="remainingUseMonth" :width="60"></TableItem>
        <TableItem title="资产净值" prop="totalDepreciation"></TableItem>
        <TableItem title="部门" prop="deptName"></TableItem>
        <TableItem title="备注" prop="remark"></TableItem>
      </Table>
      <div class="margin-top-bottom">
        <Pagination v-model="pageInfo" align="center" layout="pager" small/>
      </div>
    </div>
  </app-content>

</template>
<script>
import * as XLSX from 'xlsx';
/**
 * 资产处置详情。
 */
export default {
  name: "AssetDetails",
  data() {
    return {
      accountDate: null,
      // keyword: '',
      // showForm: false,
      // showImportModal: false,
      // 存储表格展示的数据，初始为空数组
      datas: [],
      //处置信息
      disposalData: [],
      // 存储资产类别的数据，初始为空数组
      assetsType: [],
      // 分页信息对象，包含当前页码和数据总条数
      pageInfo: {
        // 当前页码，初始为第 1 页
        page: 1,
        // 数据总条数，初始为 0
        total: 0
      },
    }
  },
  watch: {
    /**
     * 监听 pageInfo 对象的变化
     * 使用 deep 选项深度监听 pageInfo 对象的所有属性变化，
     * 当 pageInfo 发生变化时，调用 loadList 方法重新加载数据列表。
     */
    pageInfo: {
      deep: true, // 深度监听 pageInfo 对象的所有属性变化
      /**
       * 当 pageInfo 对象发生变化时的处理函数
       * 调用 loadList 方法重新加载数据列表
       */
      handler() {
        // 重新加载数据列表
        this.loadList();
      }
    },
  },
  methods: {
    /**
     * 导出Excel
     */
    exportExcel() {
      try {
        // 导出所有数据，包括合计行
        const exportData = this.disposalData;

        if (exportData.length === 0) {
          this.$Message.warning('没有可导出的数据');
          return;
        }

        // 准备导出数据，保持与表格显示一致的顺序
        const data = exportData.map((item, index) => {
          // 对于合计行，序号显示为空
          return {
            '序号': index+1,
            '资产编号': item.assetsCode || '',
            '资产类别': item.assetsTypeName || '',
            '资产名称': item.assetsName || '',
            '单位': item.specification || '',
            '录入时间': item.luruDate || '',
            '调出数量': item.disposalNumber || '',
            '调出时间': item.disposalDate || '',
            '调出说明': item.disposal || '',
            '单价': item.price || 0,
            '数量': item.number || 0,
            '资产原值': item.originalValue || 0,
            '折旧次数': item.expectUseMonth || 0,
            '单次折旧额': item.currentMonthDepreciation || 0,
            '折旧起始日期': item.checkDate || '',
            '上次折旧日期': item.entryDate || '',
            '剩余次数': item.remainingUseMonth || 0,
            '资产净值': item.totalDepreciation || 0,
            '部门': item.deptName || '',
            '备注': item.remark || ''
          };
        });
        // 创建工作表
        const ws = XLSX.utils.json_to_sheet(data, { skipHeader: false });

        // 创建工作簿
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '固定资产调出表');

        // 导出文件
        XLSX.writeFile(wb, '固定资产调出表.xlsx');

        // 简单延时后显示成功提示，改善用户体验
        setTimeout(() => {
          this.$Message.success('数据导出成功，请查看浏览器下载列表');
        }, 100);
      } catch (error) {
        console.error('导出失败:', error);
        this.$Message.error('导出失败');
      }
    },
    async loadDisposalData() {
      try {
        const { data } = await this.$api.assets.disposal.list();
        this.disposalData = data || [];
      } catch (error) {
        console.error('获取资产处置列表失败:', error);
      }
    },
  },
  mounted() {

    this.loadDisposalData();
  }
}
</script>
<style scoped lang="less">
.h-panel-bar {
  display: flex; /* 使用 Flexbox 布局 */
  justify-content: space-between; /* 让子元素两端对齐 */
  align-items: center; /* 垂直居中对齐 */
}
</style>